module.exports = __webpack_public_path__ + "static/media/round2_1.134c6d0a.jpeg";